import { useQuery } from "@tanstack/react-query"
import { getOrdersList, getTransfersList } from "customerAttachments/apis"

// At this stage, set a fixed pageSize and pageNumber, but in the future, these might need to be modified.

const useGetTransferOrders = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["transferOrders"],
    queryFn: () => getTransfersList({ pageSize: 10, page: 1 }),
    select: (data) => data.Data,
  })
  return { data, isLoading }
}

const useGetPurchaseOrders = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["purchaseOrders"],
    queryFn: () => getOrdersList({ pageSize: 10, page: 1 }),
    select: (data) => data.Data,
  })
  return { data, isLoading }
}

export { useGetPurchaseOrders, useGetTransferOrders }
